/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const API_ROOT = `${process.env.API}/activitypass`;
